import { createContext, useContext } from "react";
import { Navigate } from "react-router-dom";
import { useQuery } from "react-query";
import { axiosInstance } from "../model/services/BaseService";

export const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthGate({ children }) {
  const token = localStorage.getItem("token");

  const { data, isLoading, isError } = useQuery(
    "me",
    () => axiosInstance.get("/users/me").then(res => res.data),
    {
      enabled: Boolean(token),
      retry: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  if (!token) return <Navigate to="/" />;
  if (isLoading) return null;
  if (isError || !data?.userId) {
    localStorage.removeItem("token");
    localStorage.removeItem("exp");
    localStorage.removeItem("store-information");
    localStorage.removeItem("active-store");
    return <Navigate to="/" />;
  }

  return (
    <AuthContext.Provider value={data}>
      {children}
    </AuthContext.Provider>
  );
}
